import React, { useEffect, useState, forwardRef, createRef } from 'react';
import { Row, Col, Form } from 'react-bootstrap';
import SvgIcon from '@material-ui/core/SvgIcon';
import { Slider, Collapse, Card, CardContent, Button } from '@material-ui/core';
import PropTypes from 'prop-types';
import { TextInput, SelectInput, CheckboxInput } from '../../../Helpers/Inputs';
import NumberFormatDollars from '../../../Helpers/Formatters/NumberFormatDollars';
import ErrorHandler from '../../../Helpers/Errors/ErrorHandler';
import { CollapsibleBasicInfoSummary } from '../../../Quoters/Common/SubComponents/BasicInfoSummary';
import ExpandMoreIcon from '../../../../icons/expand-more.svg';
import DigitalCoverageAmounts from '../../../Helpers/Lists/CoverageAmounts/DigitalCoverageAmounts';
import StyledRadioInput from '../../../Helpers/Inputs/StyledRadioInput';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import { red } from '@material-ui/core/colors';
import './Quoter.scss';
import QuoteFor from '../SubComponent/QuoteFor';
import { SESSION_STORAGE_ACCOUNT_KEY, getSessionStorageItem, SESSION_STORAGE_TERM_LIFE_INSURANCE_OBJECT_KEY, SESSION_STORAGE_ATTESTATION } from '../../../../sessionStorage';
import NoQuoteAvailable from '../../../Quoters/Common/SubComponents/NoQuoteAvailable';
import CircularProgress from '@material-ui/core/CircularProgress';
import HealthClasses from "../../../Helpers/Lists/HealthClasses";
import FormGroup from '@material-ui/core/FormGroup';
import ProductDetails from "../SubComponent/ProductDetails";
import QuoteCard from '../SubComponent/QuoteCard';
import Tooltip from '@material-ui/core/Tooltip';
import InfoIcon from '@material-ui/icons/Info';
import NumberFormat from 'react-number-format';
import States from "../../../Helpers/Lists/States";
import { useForm } from 'react-hook-form/dist/react-hook-form.ie11';
import { httpRequest } from '../../../../httpRequest';
import QuoterCoverageLength from '../../../Helpers/Lists/CoverageLengths/QuoterCoverageLengths';
import PopUpIntro from '../PopUps/PopUpIntro';
import UWPopUp from '../PopUps/UWPopUp/UWPopUp';

const useStyles = makeStyles((theme) => ({
  smallText: {
    fontSize: '12px',
  },
  blueText: {
    fontSize: '12px',
    color: '#007AB8',
    cursor: 'pointer',
    backgroundColor: '#fff',
    border: 'none',
  },
  warningIcon: {
    color: red[500],
  },
  MuiAccordionroot: {
    "&.MuiAccordion-root:before": {
      backgroundColor: "#f7f7f7 ",
      height: '0px',
    },
    "&.MuiPaper-elevation1": {
      boxShadow: 'none',
    },
    boxShadow: 'none',
  },
  accordionDetails: {
    padding: '30px 16px 16px',
    display: 'block',
  },
  primaryColor: {
    color: theme.palette.primary.main,
  },
  primaryBackground: {
    backgroundColor: theme.palette.primary.main,
  }
}));

const LightTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: theme.palette.common.white,
    color: 'rgba(0, 0, 0, 0.87)',
    boxShadow: theme.shadows[1],
    fontSize: 11,
  },
}))(Tooltip);

export default function Quoter(props) {
  const classes = useStyles();

  const tableListOptions = () => {
    return [
      { label: "Table A", value: "A" },
      { label: "Table B", value: "B" },
      { label: "Table C", value: "C" },
      { label: "Table D", value: "D" },
      { label: "Table E", value: "E" },
      { label: "Table F", value: "F" },
      { label: "Table G", value: "G" },
      { label: "Table H", value: "H" },
      { label: "Table I", value: "I" },
    ]
  }

  const getHealthClassfromBMI = (bmi) => {
    if (bmi < 30)
      return 'best';
    else if (bmi >= 30 && bmi < 36)
      return 'better';
    else if (bmi >= 36 && bmi < 40)
      return 'good';
    else
      return 'better';
  }

  function getPersonalHealthClass(termHealthClass) {
    switch (termHealthClass) {
      case 'best':
      default:
        return 'PP';
      case 'better':
        return 'P';
      case 'good':
        return 'R';
    }
  }

  const covrServicesUrl = process.env.REACT_APP_COVR_SERVICES_URL;
  const accountObj = getSessionStorageItem(SESSION_STORAGE_ACCOUNT_KEY);
  const formState = getSessionStorageItem(SESSION_STORAGE_TERM_LIFE_INSURANCE_OBJECT_KEY);
  const ONECLICKTYPEID_MS_FULLUW = 28;

  const [coverageAmount, setCoverageAmount] = useState(parseInt(props.formState.coverageAmount, 10));
  const [expanded, setExpanded] = useState(true);
  const [loading, setLoading] = useState(false);
  const [quoteRan, setQuoteRan] = useState(false);
  const [quoteResults, setQuoteResults] = useState([]);
  const [popup, setPopUp] = useState(false);
  const [uWPopup, setUWPopUp] = useState(false);
  const [popUpInfo, setPopUpInfo] = useState({});
  const [showAlertMessage, setshowAlertMessage] = useState(false);
  const [isCoverageLoading, setCoverageLoading] = useState(false);
  const [coverageOptions, setCoverageOptions] = useState([]);

  const handlePopupClose = () => {
    setPopUp(false);
  }

  const printRef = createRef();
  const { register } = useForm({
    mode: 'onBlur',
    reValidateMode: 'onBlur',
  });

  const runQuote = (getIsSubscribed) => {
    setLoading(true);
    setCoverageLoading(true);
    setQuoteRan(true);
    setshowAlertMessage(false);
    // if coming from citi api, the dob will always be masked
    const birthDate = props.allForms.pages.retrieveAccount.policyOwner === 'yes' ? '' : props.allForms.pages.insuredBasicInfo.birthdate;

    let dob;
    let stringOfDob;
    if (birthDate) {
      dob = (birthDate).split('/')
      stringOfDob = dob[0] + dob[1] + dob[2];
    }
    const ownerState = props.allForms.pages.retrieveAccount.state;
    const piState = props.allForms.pages.insuredBasicInfo.state;

    const gender = props.allForms.pages.retrieveAccount.policyOwner === 'yes' ? props.allForms.pages.retrieveAccount.gender : props.allForms.pages.insuredBasicInfo.gender;
    const tobacco = props.allForms.pages.retrieveAccount.policyOwner === 'yes' ? props.allForms.pages.retrieveAccount.tobacco : props.allForms.pages.insuredBasicInfo.tobacco;
    let healthClass;

    if (props.formState.healthClass === "Personalized Health Class") {
      let bmi;
      if (props.fullFormState.pages.retrieveAccount.bmi) {
        bmi = props.fullFormState.pages.retrieveAccount.bmi;
      }
      if (!bmi && props.fullFormState.pages.insuredBasicInfo.bmi) {
        bmi = props.fullFormState.pages.insuredBasicInfo.bmi;
      }
      const bmiHealthClass = getHealthClassfromBMI(bmi);
      const personalizedHealthClass = getPersonalHealthClass(bmiHealthClass);
      healthClass = personalizedHealthClass;
      props.onFieldChange('personalizedHealthClass', personalizedHealthClass);
    } else {
      healthClass = props.formState.healthClass;
    }

    const queryParams = {
      carrierId: 0,
      dob: stringOfDob,
      dobIsMasked: birthDate === '' ? true : false,
      state: piState || ownerState,
      ownerState: ownerState,
      gender: gender,
      faceAmount: coverageAmount,
      healthClass: healthClass,
      term: props.formState.term || "20",
      accidentalDBRider: props.formState.accidentalDeathBenefit,
      terminalRider: props.formState.acceleratedDeathBenefit,
      wopRider: props.formState.waverOfPremium,
      childRider: props.formState.childRider && Number(props.formState.benefitAmount) || 0,
      substandard: props.formState.healthClass === 'RR' ? props.formState.tableRating || 'B' : null,
      oneClickAccountId: accountObj.account.oneClickAccountId,
      tobacco: tobacco === '' ? 'false' : tobacco,
      source: 'Morgan Stanley',
      underwritingType: props.formState.underwritingType || "FullUW",
      terms: ['10', '15', '20', '25', '30', '35', '40'],
      SessionId: accountObj.sessionId,
      oneClickTypeId: ONECLICKTYPEID_MS_FULLUW,
    };

    httpRequest.post(`${covrServicesUrl}/api/MorganStanleyProduct/GetTermQuoteResults`, queryParams)
      .then((data) => {
        if (getIsSubscribed()) {
          if (data.success) {
            setQuoteResults(data.content);
          }
          setLoading(false);
        }
      })
      .catch((error) => {
        if (getIsSubscribed()) {
          ErrorHandler(error, setQuoteResults);
          setLoading(false);
        }
      });

    httpRequest.post(`${covrServicesUrl}/api/MorganStanleyProduct/GetTermCoverageOptionQuotes`, queryParams)
      .then((data) => {
        if (getIsSubscribed()) {
          if (data.success) {
            setCoverageOptions(data.content);
          }
          setCoverageLoading(false);
        }
      })
      .catch((error) => {
        if (getIsSubscribed()) {
          ErrorHandler(error, setCoverageOptions);
          setCoverageOptions([])
          setCoverageLoading(false);
        }
      });
  };

  let debounce = null;
  useEffect(() => {
    if (props.formState.coverageAmount === null || props.formState.term === null) {
      return;
    }

    setLoading(true);

    let isSubscribed = true;

    if (debounce) {
      clearTimeout(debounce);
    }

    debounce = setTimeout(() => runQuote(() => isSubscribed), 1000);

    return () => {
      clearTimeout(debounce);
      isSubscribed = false;
    };
  }, [coverageAmount, props.formState.term, props.formState.healthClass, props.formState.premiumAs, props.formState.underwritingType, props.formState.waverOfPremium, props.formState.acceleratedDeathBenefit, props.formState.accidentalDeathBenefit, props.formState.childRider, props.formState.benefitAmount, props.formState.tableRating]);

  const handleClick = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };

  const handleChange = (event, newValue) => {
    setCoverageAmount(newValue);
    props.onFieldChange('coverageAmount', newValue)
  };

  const quoteOnClick = (quotes) => {
    const fullFormState = { ...props.fullFormState };
    fullFormState.pages.quoter.carrierName = quotes.carrierName;
    fullFormState.pages.quoter.carrierLogoUrl = quotes.logoUrl;
    if(props.formState.premiumAs === "monthly"){
      fullFormState.pages.quoter.premium = parseFloat(quotes.monthlyRate).toFixed(2);
    }else{
      fullFormState.pages.quoter.premium = parseFloat(quotes.annualRate).toFixed(2);
    }
    fullFormState.pages.quoter.annualPremium = parseFloat(quotes.annualRate).toFixed(2);
    fullFormState.pages.quoter.carrierID = quotes.carrierID;
    fullFormState.pages.quoter.riderCost = quotes.riderCost;
    fullFormState.pages.quoter.riderCostMonthly = quotes.riderCostMonthly;
    fullFormState.pages.quoter.product = quotes.morganStanleyProductName;
    fullFormState.pages.quoter.productID = quotes.productID;
    fullFormState.pages.quoter.bmsCarrierID = quotes.bmsCarrierID;
    fullFormState.pages.quoter.bmsPlanID = quotes.bmsPlanID;
    fullFormState.pages.quoter.morganStanleyCarrierCode = quotes.morganStanleyCarrierCode;
    fullFormState.pages.quoter.morganStanleyCarrierName = quotes.morganStanleyCarrierName;
    fullFormState.pages.quoter.morganStanleyProductCode = quotes.morganStanleyProductCode;
    sessionStorage.removeItem(SESSION_STORAGE_ATTESTATION);
    props.onNext();
  }

  const setPopUpDetails = (field) => {
    const popUpDetail = {}
    switch (field) {
      case 'healthClass':
        popUpDetail.field = field
        popUpDetail.heading = "Health Class";
        popUpDetail.details = "When your client applies for life insurance, the underwriter will rate their overall health and lifestyle and assign them to a risk class. These risk classes dictate how much they will pay for life insurance. To get the best quote possible, your client should choose the health class that best represents them.";
        break;
      case 'term':
        popUpDetail.field = field
        popUpDetail.heading = "Coverage Length";
        popUpDetail.details = "<p>In general, younger people select longer life insurance policies, while people closer to retirement pick shorter terms.</p> <p>The goal for most people when choosing a coverage length is to protect their loved ones throughout their income-earning years when their unexpected death would leave loved ones most vulnerable to financial hardship.</p>";
        break;
      case 'coverageAmount':
        popUpDetail.field = field
        popUpDetail.heading = "Coverage Amount";
        popUpDetail.details = "Coverage amount (also known as death benefit) is the sum of money paid to the beneficiaries of the life insurance policy after the insured's death. Use the tools below to determine an adequate amount of coverage.";
        break;
      default:
        popUpDetail.field = ""
        popUpDetail.heading = "";
        popUpDetail.details = "";
        break;
    }
    setPopUpInfo(popUpDetail);
    setPopUp(true)
  }

  return (
    <div>      
      <div className='quoter-message'>
      {showAlertMessage ?
        <div className="alert alert-success mt-n4 mr-n3" role="alert">
         <strong>Success</strong>&nbsp;&nbsp;&nbsp;&nbsp;Quote has been saved
        </div>
        : null} 
      </div>
      <Row className="quoter">
        <Col lg={4} className="mb-3 quoter-pane-left">
          <Form onSubmit={e => e.preventDefault()} className='formContainer'>
            <h2><b>Your Coverage Details</b></h2>
            <h3><b>Select Amount</b></h3>

            <Form.Group className='mx-5 mb-0'>
              <div className="d-flex">
                <TextInput
                  name="coverageAmount"
                  id="coverageAmount"
                  aria-label="Coverage Amount"
                  value={coverageAmount}
                  onChange={(e) => handleChange(e, e.target.value)}
                  variant="outlined"
                  InputProps={{
                    inputComponent: NumberFormatDollars,
                    className: 'coverage-input',
                  }}
                  style={{ backgroundColor: '#f2f2f2', borderColor: 'white !important' }}
                />
                <Tooltip title="Help Me Decide" placement="right" enterTouchDelay={0} className='toolInfo'>
                  <LightTooltip><a onClick={() => { setPopUpDetails('coverageAmount') }} className='mt-4' role='button'><InfoIcon color="primary" className='ml-2' /></a>
                  </LightTooltip>
                </Tooltip>
              </div>
            </Form.Group>

            <Form.Group className="ml-3 mr-4">
              <Slider
                min={25000}
                max={25000000}
                step={null}
                value={parseInt(coverageAmount, 10)}
                onChange={handleChange}
                className="m-2"
                marks={DigitalCoverageAmounts(25000, 25000000, 555000)}
                role="slider"
                aria-valuemin={25000}
                aria-valuenow={parseInt(coverageAmount, 10)}
                aria-valuemax={25000000}
                aria-labelledby="coverageAmount"
              />
            </Form.Group>

            <Accordion expanded={expanded} className="filter-accordion pb-0" onChange={() => handleClick('filter-panel')} classes={{ root: classes.MuiAccordionroot }}>
              <AccordionSummary aria-controls={`filter-content`} id={`filter-header`} onClick={() => setExpanded(!expanded)} className='p-0 expand'>
                <SvgIcon component={ExpandMoreIcon} className={!expanded ? 'expanded' : ''} />Options
              </AccordionSummary>
              <AccordionDetails className='row pb-0'>
                <Form.Group className="w-100">
                <Row className='no-gutters'>
                    <Col md={11}>
                    <SelectInput
                      name="term"
                      id="term"
                      value={props.formState.term}
                      onChange={(e) => props.onFieldChange('term', e.target.value)}
                      label="Years of Coverage"
                      selectOptions={QuoterCoverageLength()}
                      hideEmptyOption
                    />
                        </Col>
                    <Col md={1} className='pl-0 pt-3'>
                    <Tooltip title="Help Me Decide" placement="right" enterTouchDelay={0}>
                      <LightTooltip><a onClick={() => { setPopUpDetails('term') }} className='mx-0' role='button'><InfoIcon color="primary" className='ml-2' /></a>
                      </LightTooltip>
                    </Tooltip>
                    </Col>
                  </Row>
                </Form.Group>

                <Form.Group className="w-100">
                <Row className='no-gutters'>
                    <Col md={11}>
                    <SelectInput
                      name="healthClass"
                      id="healthClass"
                      value={props.formState.healthClass}
                      onChange={(e) => props.onFieldChange('healthClass', e.target.value)}
                      label="Health Class"
                      hideEmptyOption
                      selectOptions={HealthClasses(true, true, formState.pages.insuredBasicInfo.height, formState.pages.insuredBasicInfo.weight)}
                    />
                     </Col>
                    <Col md={1} className='pl-0 pt-3'>
                    <Tooltip title="Help Me Decide" placement="right" enterTouchDelay={0}>
                      <LightTooltip><a onClick={() => { setPopUpDetails('healthClass') }} className='mx-0' role='button'><InfoIcon color="primary" className='ml-2' /></a>
                      </LightTooltip>
                    </Tooltip>
                    </Col>
                  </Row>
                </Form.Group>

                {props.formState.healthClass === 'RR' &&
                  <Form.Group className="w-100">
                    <SelectInput
                      name="tableRating"
                      id="tableRating"
                      value={props.formState.tableRating || (props.formState.healthClass === 'RR' ? 'B' : 'A')}
                      onChange={(e) => props.onFieldChange('tableRating', e.target.value)}
                      label="Table Rating"
                      hideEmptyOption
                      selectOptions={tableListOptions()}
                    />
                  </Form.Group>
                }

                <Form.Group className='w-100'>
                  <p className="subTitle">Premium Mode</p>
                  <StyledRadioInput
                    name="premiumAs"
                    id="premiumAs"
                    value={props.formState.premiumAs}
                    options={[{ value: 'monthly', label: 'Monthly' }, { value: 'annually', label: 'Annual' }]}
                    onChange={(e) => props.onFieldChange('premiumAs', e)}
                    errors={props.error}
                    inputRef={props.inputRef}
                  />
                </Form.Group>
                <Form.Group className="w-100">
                  <Row className='no-gutters'>
                    <Col md={11}>
                      <SelectInput
                        name="underwritingType"
                        id="underwritingType"
                        value={props.formState.underwritingType}
                        onChange={(e) => props.onFieldChange('underwritingType', e.target.value)}
                        label="Underwriting Type"
                        selectOptions={[
                          { label: "Full Underwriting", value: "FullUW" },
                          { label: "Accelerated  Underwriting", value: "AU" },
                        ]}
                        hideEmptyOption
                      />
                    </Col>
                    <Col md={1} className='pl-0 pt-3'>
                      <Tooltip title="Help Me Decide" placement="right" enterTouchDelay={0}>
                        <LightTooltip><a onClick={() => { setUWPopUp(true) }} className='mx-0' role='button'><InfoIcon className='ml-2' color="primary" /></a>
                        </LightTooltip>
                      </Tooltip>
                    </Col>
                  </Row>
                </Form.Group>
                <p className='col-12 subTitle pl-0'>Optional Riders</p>

                <FormGroup className="checkboxes pl-3 pt-1">
                  <Tooltip placement="top-start" className="ml-1" title="Under certain conditions, the premium payment may be waived in the event the primary insured becomes totally disabled as defined in the rider.">
                    <LightTooltip
                      placement="top-start"
                    >
                      <span>
                        <CheckboxInput
                          className="checkBoxInput"
                          name="waverOfPremium"
                          id="waverOfPremium"
                          checked={props.formState.waverOfPremium}
                          onChange={(e) => props.onFieldChange('waverOfPremium', e.target.checked)}
                          label="Waiver of Premium"
                          inputRef={register}
                        />
                      </span>
                    </LightTooltip>
                  </Tooltip>
                  <Tooltip className="ml-1" >
                    <LightTooltip
                      placement="top"
                      title={
                        <div>
                          This benefit allows a terminally ill customer to receive an advance of their policy's death benefit while still alive.
                          <br /> It is a free feature. It won't add any cost.
                        </div>
                      }
                    >
                      <span>
                        <CheckboxInput
                          className="checkBoxInput"
                          name="acceleratedDeathBenefit"
                          id="acceleratedDeathBenefit"
                          checked={props.formState.acceleratedDeathBenefit}
                          onChange={(e) => props.onFieldChange('acceleratedDeathBenefit', e.target.checked)}
                          label="Accelerated Death Benefit"
                          inputRef={register}
                        />
                      </span>
                    </LightTooltip>
                  </Tooltip>

                  <Tooltip className="ml-1" title="Provides coverage that pays an additional death benefit,if death results from an accident.">
                    <LightTooltip
                      placement="top-start"
                    >
                      <span>
                        <CheckboxInput
                          className="checkBoxInput"
                          name="accidentalDeathBenefit"
                          id="accidentalDeathBenefit"
                          checked={props.formState.accidentalDeathBenefit}
                          onChange={(e) => props.onFieldChange('accidentalDeathBenefit', e.target.checked)}
                          label="Accidental Death Benefit"
                          inputRef={register}
                        />
                      </span>
                    </LightTooltip>
                  </Tooltip>

                  <Tooltip className="ml-1" title="Additional benefit option to provide life insurance on a client's children while they are young. It can be converted to a permanent policy at a later time.">
                    <LightTooltip
                      placement="top-start"
                    >
                      <span>
                        <CheckboxInput
                          className="checkBoxInput"
                          name="childRider"
                          id="childRider"
                          checked={props.formState.childRider}
                          onChange={(e) => props.onFieldChange('childRider', e.target.checked)}
                          label="Child Rider"
                          inputRef={register}
                        />
                      </span>
                    </LightTooltip>
                  </Tooltip>

                  {props.formState.childRider &&
                    <Form.Group>
                      <SelectInput
                        name="benefitAmount"
                        id="benefitAmount"
                        value={props.formState.benefitAmount}
                        onChange={e => props.onFieldChange('benefitAmount', e.target.value)}
                        label="Child Rider"
                        selectOptions={[
                        { label: "$1,000", value: "1000" },
                        { label: "$2,000", value: "2000" },
                        { label: "$3,000", value: "3000" },
                        { label: "$4,000", value: "4000" },
                        { label: "$5,000", value: "5000" },
                        { label: "$6,000", value: "6000" },
                        { label: "$7,000", value: "7000" },
                        { label: "$8,000", value: "8000" },
                        { label: "$9,000", value: "9000" },
                        { label: "$10,000", value: "10000" },
                      ]}
                   />
                 </Form.Group>
                  }
                </FormGroup>
              </AccordionDetails>
            </Accordion>

            <CollapsibleBasicInfoSummary
              gender={(formState && formState.pages.retrieveAccount.policyOwner === 'yes' ? formState.pages.retrieveAccount.gender : formState.pages.insuredBasicInfo.gender)}
              state={(formState && formState.pages.retrieveAccount.policyOwner === 'yes' ? formState.pages.retrieveAccount.state : formState.pages.insuredBasicInfo.state)}
              birthdate={(formState && formState.pages.retrieveAccount.policyOwner === 'yes' ? formState.pages.retrieveAccount.birthdate : formState.pages.insuredBasicInfo.birthdate)}
              tobacco={(formState && formState.pages.retrieveAccount.policyOwner === 'yes' ? formState.pages.retrieveAccount.tobacco : formState.pages.insuredBasicInfo.tobacco)}
              showEditLink={true}
              editLinkOnClick={props.onBack}
              height={(formState && formState.pages.retrieveAccount.policyOwner === 'yes' ? formState.pages.retrieveAccount.height : formState.pages.insuredBasicInfo.height)}
              weight={(formState && formState.pages.retrieveAccount.policyOwner === 'yes' ? formState.pages.retrieveAccount.weight : formState.pages.insuredBasicInfo.weight)}
            />

          </Form>
        </Col>

        <Col lg={8} className="quoter-pane-right pl-0">
          <Row>
            <Col className="pr-0" xs={12}>
              <div className="quote-result-section w-100 mb-2">
                <QuoteFor formState={props.formState} showPrintOrSave={!loading && !isCoverageLoading } fullFormState={props.fullFormState} coverageAmount={parseInt(coverageAmount, 10)} term={props.formState.term} isProspectMode={props.isProspectMode} separator content={printRef} setshowAlertMessage={setshowAlertMessage} />
              </div>
            </Col>
          </Row>
          <Row>
            <Col>
              {props.isProspectMode &&
                <div className="mb-2 ml-2 text-danger">This is a prospective quote and is for informational purposes only.</div>
              }
            </Col>
          </Row>
          <QuoteResult
            formState={props.formState}
            result={quoteResults}
            isAccel={true}
            quoteRan={quoteRan}
            loading={loading}
            onNext={props.onNext}
            quoteOnClick={(quotes) => quoteOnClick(quotes)}
            //quoteOnClick={() => {props.onNext();}}
            hideAllDefault={true}
            coverageAmount={coverageAmount}
            premiumAs={props.formState.premiumAs}
            isProspectMode={props.isProspectMode}
            fullFormState={formState}
            ref={printRef}
            insuredState={formState.pages.insuredBasicInfo.state}
            ownerState={formState.pages.retrieveAccount.state}
            onMultiFieldChange={props.onMultiFieldChange}
            allForms={props.allForms}
            coverageOptions={coverageOptions}
            classes={classes}
          />
          {(!loading && quoteResults && quoteResults.length > 0) &&
            <Row className='pt-5 pl-3'>
              <h4 >Compare Coverage Lengths</h4>
              {
                isCoverageLoading ?
                  <Row className="d-flex">
                    <CircularProgress className="mt-5 mb-5" />
                  </Row>
                  :
                  coverageOptions && coverageOptions.length > 0 ?
                    <Row className='w-100'>
                      {coverageOptions.map((index, i) => {
                        return (
                          <Col className='compare-coverage-card pr-0' key={`compare-coverage-col-${i}`} id={`compare-coverage-col-${i}`} name="compare-coverage-col">
                            <Card variant="outlined" className="mt-2" id={`compare-coverage-card-info-${i}`} name="compare-coverage-card-info">
                              <CardContent className="mt-0 pb-2" id={`compare-coverage-card-content-${i}`} name="compare-coverage-card-content">
                                <div>
                                  <div id={`compare-coverage-term-${i}`} name="compare-coverage-term">{index.term} Year Term</div>
                                  <div id={`compare-coverage-amount-${i}`} name="compare-coverage-amount">
                                    $<NumberFormat
                                      className="quote-amount-dollars-small"
                                      value={index.coverageAmount}
                                      displayType={'text'}
                                      thousandSeparator={true}
                                      decimalScale={2}
                                      fixedDecimalScale={true}
                                    /> / year
                                  </div>
                                  <Button id={`quote-term-btn-${i}`} name="quote-term-btn" className={`product-details-button pl-0 ${classes.primaryColor}`} onClick={() => props.onFieldChange('term', index.term)}>QUOTE TERM</Button>
                                </div>
                              </CardContent>

                            </Card>
                          </Col>)
                      })}
                    </Row>
                    :
                    <Row className='mt-5'>
                      <p>No result found.</p>
                    </Row>
              }
            </Row>}
        </Col>
      </Row>
      <PopUpIntro
        show={popup}
        onHide={handlePopupClose}
        onFieldChange={(val) => props.onFieldChange(popUpInfo.field, val)}
        onCoverageAmountChange={(face) => {
          setCoverageAmount(face);
          props.onFieldChange(popUpInfo.field, face);
        }}
        heading={popUpInfo.heading}
        details={popUpInfo.details}
        field={popUpInfo.field}
      />
      <UWPopUp
        show={uWPopup}
        onHide={() => setUWPopUp(false)}
      />
    </div>
  )
}

const QuoteResult = forwardRef((props, ref) => {
  const [expanded, setExpanded] = useState(true);
  const [quoteCards, setQuoteCards] = useState([]);
  const [highlightedCards, setHighlightedCards] = useState([]);
  const [printCards, setPrintCards] = useState([]);  
  const [sortBy, setSortBy] = useState('price');
  const isMonthlyPremium = props.formState.premiumAs === "monthly";

  useEffect(() => {
    if (!props.result || props.result.length < 1) {
      return;
    }

    const getPricePremium = (a, b) => {
      return isMonthlyPremium ? a.monthlyRate - b.monthlyRate : a.annualRate - b.annualRate;
    }
    const highlightedCardsArray = [];
    if (props.result.length >= 4) {
      // Tag the 3 highlighted cards

      const bestPrice = props.result.sort((a, b) => getPricePremium(a, b) || b.totalUnweightedScore - a.totalUnweightedScore)[0];
      bestPrice.isBestPrice = true;

      const fastest = props.result.sort((a, b) => b.speedScore - a.speedScore || getPricePremium(a, b) || b.totalUnweightedScore - a.totalUnweightedScore)[0];
      fastest.isFastest = true;

      const mostOptions = props.result.sort((a, b) => b.optionsScore - a.optionsScore || getPricePremium(a, b) || b.totalUnweightedScore - a.totalUnweightedScore)[0];
      mostOptions.isMostOptions = true;
      const highlight = [bestPrice, fastest, mostOptions];
      const sortType = ["price", "speed", "options"]

      highlight.forEach((item, index) => {
        highlightedCardsArray.push(makeQuoteCard(item, index, true, sortType[index], null, null));
        setHighlightedCards(highlightedCardsArray);
      })

    } else {
      // 1-3 cards
      if (props.result && props.result.length > 0) {
        const bestPrice = props.result.sort((a, b) => getPricePremium(a, b) || b.totalUnweightedScore - a.totalUnweightedScore);
        const sortType = ["price"]
        bestPrice.forEach((item, index) => highlightedCardsArray.push(makeQuoteCard(item, index, true, sortType[0], null, null)));
        setHighlightedCards(highlightedCardsArray);
      }
    }
    sortCards(highlightedCardsArray.length);
    sortedPrintCards(highlightedCardsArray.length);
  }, [props.result]);

  useEffect(() => {
    sortCards();
  }, [sortBy]);

  const calcOptionStars = (score) => {
    if (score < 3) {
      return 0
    }
    if (score < 6.3) {
      return 0.5
    }
    if (score < 12.3) {
      return 1
    }
    if (score < 18.3) {
      return 1.5
    }
    if (score < 24.3) {
      return 2
    }
    if (score < 27.3) {
      return 2.5
    }
    return 3
  }

  const makeQuoteCard = (quote, index, isHighlighted, sortType, isPrintCards = false) => {
    return {
      speedScore: quote.speedScore,
      priceScore: quote.monthlyRate,
      annualScore: quote.annualRate,
      optionsScore: quote.optionsScore,
      isBestPrice: quote.isBestPrice,
      isFastest: quote.isFastest,
      isMostOptions: quote.isMostOptions,
      totalScore: quote.totalUnweightedScore,
      component: (
        <QuoteCard
          isAcceleratedUnderwriting={quote.isAcceleratedUnderwriting}
          underwritingType={props.formState.underwritingType}
          carrierName={quote.carrierName}
          productName={quote.morganStanleyProductName}
          val={quote.termLength}
          annualRate={quote.annualRate}
          monthlyRate={quote.monthlyRate}
          premiumAs={props.premiumAs}
          logoUrl={quote.logoUrl}
          rating={quote.rating}
          waverOfPremium={props.formState.waverOfPremium}
          accidentalDeathBenefit={props.formState.accidentalDeathBenefit}
          childRider={props.formState.childRider}
          additionalOptionsStars={calcOptionStars(quote.optionsScore)}
          requiresMedicalExam={quote.requiresMedicalExam}
          underwritingTimeTypical={quote.underwritingTimeTypical}
          key={index}
          id={index}
          onClick={() => props.quoteOnClick(quote)}
          productDetails={
            <ProductDetails
              carrierName={quote.carrierName}
              productDescription={quote.productDescription}
              hasPermConversion={quote.hasConvertibility}
              productInformation={quote.productInformation}
              id={index}
            />
          }
          sortBy={sortType}
          isBestPrice={quote.isBestPrice}
          isFastest={quote.isFastest}
          isMostOptions={quote.isMostOptions}
          isHighlighted={isHighlighted}
          ratingAMBest={quote.ratingAMBest}
          ratingSP={quote.ratingSP}
          ratingMoodys={quote.ratingMoodys}
          ratingFitch={quote.ratingFitch}
          ratingComdex={quote.ratingComdex}
          availableRiders={quote.availableRiders}
          convertibility={quote.convertibility}
          hasPermConversion={quote.hasConvertibility}
          disclosure={quote.disclosureDetail}
          riderCost={quote.riderCost}
          riderCostMonthly={quote.riderCostMonthly}
          isProspectMode={props.isProspectMode}
          isPrintCards={isPrintCards}
          insuredState={props.insuredState}
          ownerState={props.ownerState}
        />
      ),
    };
  };

  const sortCards = (highlightedCardsArray = 0) => {
   const indexLenth = highlightedCardsArray === 0 ? highlightedCards.length : highlightedCardsArray;
    if (props.result && props.result.length > 0) {
      const sortResult = props.result.sort((a, b) => sorter(a, b, sortBy));
      const newCards = sortResult.map((r, index) => {
        return makeQuoteCard(r, index + indexLenth, false, sortBy, null, null);
      });
      setQuoteCards([...newCards]);
    }
  };

  const sortedPrintCards = (highlightedCardsArray = 0) => {
    const indexLenth = highlightedCardsArray;
    if (props.result && props.result.length > 0) {
      const sortResult = props.result.sort((a, b) => sorter(a, b, sortBy));
      const newCards = sortResult.map((r, index) => makeQuoteCard(r, index + indexLenth, false, sortBy, null, null, null, true));
      setPrintCards([...newCards]);
    }
  };

  const sorter = (a, b, sortByField) => {
    const pricePremium = isMonthlyPremium ? a.monthlyRate - b.monthlyRate : a.annualRate - b.annualRate;
    switch (sortByField) {
      case 'price':
        return pricePremium || b.totalUnweightedScore - a.totalUnweightedScore;
      case 'speed':
        return b.speedScore - a.speedScore || pricePremium || b.totalUnweightedScore - a.totalUnweightedScore;
      case 'options':
      default:
        return b.optionsScore - a.optionsScore || pricePremium || b.totalUnweightedScore - a.totalUnweightedScore;
    }
  };

  if (props.loading) {
    return (
      <div className="loading-container">
        <CircularProgress />
      </div>
    );
  }

  if (props.result && !props.result.length) {
    if (props.quoteRan) {
      return <NoQuoteAvailable subText="Some limits may have been exceeded. Please select a shorter term duration or contact our support team." />;
    } else {
      return <span />;
    }
  }

  const TooltipTitle = (
    <div className="float-left p-0 mt-2 mr-3 light-tooltip" id="product-sortby-text" name="product-sortby-text">Sort By
      <LightTooltip id="product-sortby-tooltip" name="product-sortby-tooltip" title={
        <div>
          Price - Monthly cost
          <br />
          Most Options - Additional features available
          <br />
          Fastest - The estimated time from start to finish
        </div>
      } placement="top" enterTouchDelay={0} ><InfoIcon id="product-sortby-tooltip-icon" name="product-sortby-tooltip-icon" color="primary" className="ml-2" /></LightTooltip>
    </div>
  );

  return (
    <div className="quote-result-section">
      <Row id='quote-result-row' name='quote-result-row'>
        {highlightedCards.map((card, index) => (
          <Col id={`quote-result-col-${index}`} name='quote-result-col' className="pr-0" xs={12} sm={12} md={6} lg={6} xl={4} key={index}>
            {card.component}
          </Col>
        ))}
      </Row>

      <Row className={!props.hideAllDefault ? 'd-none' : 'justify-content-center pt-4 pb-2'}>
        <Button variant="text" color="primary" onClick={() => setExpanded(!expanded)}>
          {expanded ? 'HIDE ADDITIONAL PRODUCTS' : 'SHOW ALL PRODUCTS'}
        </Button>
      </Row>

      <Collapse in={expanded}>
      <Row className="pt-3" id="all-product-content" name="all-product-content">
          <Col className="mt-auto" id="all-product-col" name="all-product-col">
            <h4 id="all-product-label" name="all-product-label"><strong>All Products</strong></h4>
          </Col>
          <Col className="pr-0" xs="auto" id="quote-unhighlighted-result-filter" name="quote-unhighlighted-result-filter">
            {TooltipTitle}
            <span className="float-right" id="sortby-content" name="sortby-content">
              <SelectInput
                className="priceDropdown"
                name="sortBy"
                id="sortBy"
                value={sortBy}
                onChange={(e) => setSortBy(e.target.value)}
                hideEmptyOption
                selectOptions={[
                  { label: 'Price', value: 'price' },
                  { label: 'Fastest', value: 'speed' },
                  { label: 'Most Options', value: 'options' },
                ]}
              />
            </span>
          </Col>
        </Row>
        <Row id="quote-unhighlighted-result-row" name="quote-unhighlighted-result-row">
          <Col id={`quote-unhighlighted-result-col-${props.id}`} name="quote-unhighlighted-result-col" className="pr-0">{quoteCards.map((q) => q.component)}</Col>
        </Row>
      </Collapse>

      <div className="d-none">
        <ComponentToPrint ref={ref} classes={props.classes} quoteCards={printCards} fullFormState={props.fullFormState} formState={props.formState} coverageAmount={props.coverageAmount} coverageOptions={props.coverageOptions} />
      </div>

    </div>
  );
})

const ComponentToPrint = forwardRef((props, ref) => {

  const basicInfoState = props.fullFormState && props.fullFormState.pages.insuredBasicInfo;
  const ownerInfo = props.fullFormState && props.fullFormState.pages.retrieveAccount;  

  const getStateName = () => {
    const insuredState = basicInfoState ? basicInfoState.state : ownerInfo.state;
    const stateName = States().map((state) => state.value === insuredState ? state.label : null);
    return stateName;
  }

  const getHealthClassName = () => {
    let healthClassName = HealthClasses().map((healthClass) => healthClass.value === props.formState.healthClass ? healthClass.label : null);

    if (healthClassName.every(element => element === null)) {
      healthClassName = props.formState.healthClass;
    }

    return healthClassName;
  }

  const getRidersList = () => {
    const riders = [];
    if (props.formState.waverOfPremium) {
      riders.push("Waiver of Premium");
    }
    if (props.formState.accidentalDeathBenefit) {
      riders.push("Accidental Death Benefit");
    }
    if (props.formState.acceleratedDeathBenefit) {
      riders.push("Accelerated Death Benefit");
    }
    if (props.formState.childRider) {
      riders.push('Child Rider: ' + props.formState.benefitAmount);
    }
    return riders;
  }

  return (
    <div ref={ref} className="pt-4">
      <img id="partner-logo" alt="partner-logo" src="/AdvisorImages/Morgan_Stanley.png" className="mb-4 mt-1" />

      <h4 className="mb-4">Insured's Information</h4>
      <Row>
        <Col lg={6} md={6} sm={6}>
          <p className="mb-1">Date of Birth: {basicInfoState && basicInfoState.birthdate ? '**/**/****' : ''}</p>
          <p className="mb-1">Gender: {basicInfoState && basicInfoState.gender === 'F' ? 'Female' : basicInfoState.gender === 'M' ? "Male" : null}</p>
          <p className="mb-1">Resident State: {basicInfoState && getStateName()}</p>
          <p className="mb-1">Tobacco Use: {basicInfoState && basicInfoState.tobacco === 'true' ? 'Currently or previously used' : basicInfoState.tobacco === 'false' ? 'No usage in the last year' : null}</p>
        </Col>

        <Col lg={6} md={6} sm={6}>
          <p className="mb-1">Health Class: {props.formState && getHealthClassName()}</p>
          <p className="mb-1">Coverage Length: {props.formState && props.formState.term}</p>
          <p className="mb-1">Coverage Amount: $
            <NumberFormat
              value={props.coverageAmount}
              displayType={'text'}
              thousandSeparator={true}
              decimalScale={2}
              fixedDecimalScale={true}
            />
          </p>
          {getRidersList().length > 0 &&
            <p className="mb-1">Optional Riders: {getRidersList().join(", ")}</p>
          }
        </Col>
      </Row>

      <p className="text-center mb-0"><b><u><i>For comparative use only</i></u></b></p>

      <Row>
        <Col>{props.quoteCards && props.quoteCards.map((q) => q.component)}</Col>
      </Row>

      <h4 className="mb-4 mt-4">Compare Coverage Lengths</h4>
      <Row>        
        <Col>
          {props.coverageOptions && props.coverageOptions.length > 0 ?
            <Row className='w-100'>
              {props.coverageOptions.map((index, i) => {
                return (
                  <Col className='compare-coverage-card pr-0' key={`compare-coverage-col-${i}`} id={`compare-coverage-col-${i}`} name="compare-coverage-col">
                    <Card variant="outlined" className="mt-2" id={`compare-coverage-card-info-${i}`} name="compare-coverage-card-info">
                      <CardContent className="mt-0 pb-2" id={`compare-coverage-card-content-${i}`} name="compare-coverage-card-content">
                        <div>
                          <div id={`compare-coverage-term-${i}`} name="compare-coverage-term">{index.term} Year Term</div>
                          <div id={`compare-coverage-amount-${i}`} name="compare-coverage-amount">
                            $<NumberFormat
                              className="quote-amount-dollars-small"
                              value={index.coverageAmount}
                              displayType={'text'}
                              thousandSeparator={true}
                              decimalScale={2}
                              fixedDecimalScale={true}
                            /> / year
                          </div>
                          <Button id={`quote-term-btn-${i}`} name="quote-term-btn" className={`product-details-button pl-0  ${props.classes.primaryColor}`}>QUOTE TERM</Button>
                        </div>
                      </CardContent>

                    </Card>
                  </Col>)
              })}
            </Row>
            :
            <Row className='m-5'>
              <p>No result found.</p>
            </Row>
          }
        </Col>
      </Row>
      <Row>
        <Col>
          <p className="mt-4 mb-3 py-1 px-2 print-text-border"><b>Not a deposit - Not FDIC or NCUSIF insured - Not guaranteed by the institution - Not insured by any federal government agency - May lose value</b></p>
        </Col>
      </Row>
      <Row>
        <Col>
          <p>Insurance products are sold through Covr Financial Technologies Inc ("Covr"). Covr sells insurance as an agent or broker by contractual agreements with its insurance carrier providers. Covr is licensed in the following states: Delaware (3000067942), Idaho (607086), California (0L77229).</p>
        </Col>
      </Row>

    </div>
  )
})

Quoter.propTypes = {
  formState: PropTypes.object.isRequired,
  onFieldChange: PropTypes.func.isRequired,
  onNext: PropTypes.func.isRequired,
};

Quoter.DefaultFormState = (prefill = false) => {
  return {
    coverageAmount: prefill ? 200000 : 1000000,
    term: '20',
    personalizedHealthClass: '',
    healthClass: 'R',
    tableRating: prefill ? 'B' : '',
    premiumAs: 'monthly',
    underwritingType: 'FullUW',
    waverOfPremium: false,
    acceleratedDeathBenefit: false,
    accidentalDeathBenefit: false,
    childRider: false,
    benefitAmount: '5000',
    carrierName: '',
    carrierLogoUrl: '',
    premium: '',
    annualPremium: '',
    product: '',
    carrierID: '',  
    bmsPlanID: '',
    bmsCarrierID: '',
  };
};



// WEBPACK FOOTER //
// ./src/components/Product/TermLifeInsurance/steps/Quoter.js